import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatArticleDate } from "../blogs/articleHelpers";
import { questionExcerpt, questionUrl } from "./questionHelpers";
import EditorialBadge from "../content/EditorialBadge";
import "./questions.css";
import { currentLang } from "../../shared/seo/links";

// Question preview, used by the questions page and (compact) the home page.
export default function QuestionPostCard({ question, compact = false }) {
  const Lng = currentLang();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const url = questionUrl(question, Lng);

  function open(e) {
    e.preventDefault();
    navigate(url);
  }

  return (
    <article className={"avc-question-card" + (compact ? " avc-question-card--compact" : "")}>
      <span className="avc-question-card__badge" aria-hidden="true">
        {Lng === "ar" ? "س" : "Q"}
      </span>
      <div className="avc-question-card__body">
        {question.editorial && (
          <div className="avc-question-card__label">
            <EditorialBadge compact />
          </div>
        )}
        <h3 className="avc-question-card__title" dir="auto">
          <a href={url} onClick={open}>
            {question.title || t("blog_is_not_available")}
          </a>
        </h3>
        <p className="avc-question-card__excerpt" dir="auto">
          {questionExcerpt(question.content, compact ? 110 : 200)}
        </p>
        <div className="avc-question-card__footer">
          {question.createdAt && (
            <time dateTime={question.createdAt}>
              <i className="far fa-clock" aria-hidden="true"></i>
              {formatArticleDate(question.createdAt, Lng)}
            </time>
          )}
          <a href={url} onClick={open} className="avc-question-card__more">
            {t("qa_read_answers")}
            <i
              className={Lng === "ar" ? "fas fa-arrow-left" : "fas fa-arrow-right"}
              aria-hidden="true"
            ></i>
          </a>
        </div>
      </div>
    </article>
  );
}
